import useStyles from "./styles";

const Ribbon = ({ ribbonName }) => {
  const classes = useStyles();

  return (
    <div className={classes.betaRibbon}>
      <span className={classes.betaBadge}>{ribbonName}</span>
    </div>
  );
};

export default Ribbon;
